module.exports = __webpack_public_path__ + "static/media/KEBAB.a55227b8.png";